import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	description: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	viewSummary: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	learnMore: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	title: {
		defaultMessage: '{failedCount}/{totalCount} items not updated',
		id: 'bulk-operations-common.submit-status.flags.partial-error-flag.title',
		description: 'Bulk edit form submission partial update error title',
	},
	description: {
		defaultMessage:
			'We were unable to update some of the items. View summary to view the items that failed to update.',
		id: 'bulk-operations-common.submit-status.flags.partial-error-flag.description',
		description: 'Bulk edit form submission partial update error flag description',
	},
	viewSummary: {
		defaultMessage: 'View summary',
		id: 'bulk-operations-common.submit-status.flags.partial-error-flag.view-summary',
		description: 'Bulk edit form submission partial update error flag action view summary',
	},
	learnMore: {
		defaultMessage: 'Learn more',
		id: 'bulk-operations-common.submit-status.flags.partial-error-flag.learn-more',
		description: 'Bulk edit form submission partial update error flag action learn more',
	},
});
export default messages;
